<template>
  <div id="loader-container" class="overlay-loader">
    <div class="loader" />
  </div>
</template>
<script setup lang="ts">
/**
 * COMPONENT LIFECYLE HOOKS
 * (methods that run at certain stages of the component lifecycle)
 */

/**
 * The following work can be done after server side rendering, so adding it here.
 * This runs in the browser when the page is being hydrated after SSR.
 * - Hide the overlay loader when the user comes to the page from the
 * browser's back button
 */

/**
 * Define the pageshow event handler
 */
const handlePageShow = (event: PageTransitionEvent) => {
  // Check if the page is being loaded from the backward/forward cache
  if (event.persisted) {
    // Hide the overlay loader
    hideOverlayLoader();

    /**
     * Also, hide the notification loader if it exists
     *
     * This is done to avoid the above issue with the notification loader
     */

    // Get the notification container
    const notificationContainer = document.getElementById(
      'notificationContainer'
    );

    // Find the notification loader
    const loader = notificationContainer?.querySelector(
      '#notification-loader-container'
    );

    // Update the styles
    loader?.classList?.remove('show-overlay-loader');
    loader?.classList?.add('hide-loader');
  }
};

onMounted(() => {
  /**
   * Add a listener to listen for the 'pageshow' event which is fired when the
   * user navigates to a page.
   *
   * This is done to avoid an issue where the overlay loader doesn't get removed
   * when the user comes back to the page from the browser's back button.
   *
   * This issue occurs on browsers/devices with extensive caching (such as Mac
   * Safari, iPhone Safari, etc.), also known as backward/forward cache.
   *
   * Other browsers generally reexecute the Javascript when the user uses the
   * browser's back button, so the issue occurs very rarely.
   */
  window.addEventListener('pageshow', handlePageShow);
});

// Remove listeners before unmounting
onBeforeUnmount(() => {
  window.removeEventListener('pageshow', handlePageShow);
});
</script>
